angular.module("ainapp")
    .controller("addDriverPaymentSheetController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Driver Payment Sheet";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Driver Payment Sheet").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response2) {
                $scope.Employees = response2.data;
            })

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetDriverPaymentSheet(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.UpdateDetails = function (data) {

                $scope.driverData = data;
                $scope.driverData.Date = new Date($scope.driverData.Date);

                angular.forEach(data.DriverPaymentSheetCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })



                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {

                    e.Date = new Date(e.Date);
                    e.EndDate = new Date(e.EndDate);

                    var costs = angular.copy($scope.CostCenters);
                    if (e.DriverPaymentSheetCosts.length > 0) {
                        angular.forEach(e.DriverPaymentSheetCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }


                });

                if (data.DriverPaymentSheetDetails.length <= 5) {

                    var temp2 = 5 - data.DriverPaymentSheetDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        $scope.InsertRow();
                    }
                }


            }


            $scope.InsertRow = function () {


                var driverPaymentSheetDetails = {

                    Remarks: "",
                    EmployeeType: "",
                    PayType: $scope.driverData.PayType,
                    VehicleType: "Own Car",
                    AccountMasterId: "",
                    EmployeeId: "",
                    PerDayRate: 0,
                    PerOrderRate: 0,
                    CompanyCommission: 0,
                    TotalOrders: 0,
                    TotalAmount: 0,
                    TotalCompanyAmount: 0,
                    TotalEarned: 0,
                    Bonus: 0,
                    Deduction1: 0,
                    Deduction2: 0,
                    Deduction3: 0,
                    Deduction4: 0,
                    Deduction5: 0,
                    Deduction6: 0,
                    TotalDeduction: 0,

                    MonthlyAmount: 0,
                    TotalDays: $scope.TotalDays,

                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",
                    CostCenters: angular.copy($scope.CostCenters),
                }


                $scope.driverData.DriverPaymentSheetDetails.push(driverPaymentSheetDetails);
            }

            $scope.changeDate = function () {

                var monthno = 1;
                angular.forEach($scope.MonthsArr2, function (e) {
                    if (e.Name == $scope.driverData.Month) {
                        monthno = e.Id;
                    }
                })

                $scope.TotalDays = new Date($scope.driverData.Year, monthno, 0).getDate();

                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {
                    e.TotalDays = $scope.TotalDays;
                    if (e.AccountMasterId > 0 && e.EmployeeId > 0) {
                        $scope.click(e, 1);
                    }
                })

            }

            $scope.changePayType = function () {

                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {
                    e.PayType = angular.copy($scope.driverData.PayType);
                    //                    setTimeout(function () {
                    //                        $scope.click(e, 1);
                    //                    }, 5000);
                    if (e.AccountMasterId > 0 && e.EmployeeId > 0) {
                        $scope.click(e, 1);
                    }

                })
            }

            $scope.Init = function () {


                $scope.ViewVal = 0;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                $scope.monthNo = month + 1;
                var monthName = $scope.MonthsArr[month].Name;

                var d = new Date(year, month, 0).getDate();

                $scope.TotalDays = new Date(year, $scope.monthNo, 0).getDate();

                $scope.print = {
                    IsPrint: false,
                }

                $scope.driverData = {
                    Date: new Date(),
                    Remarks: "",
                    Year: year,
                    Month: monthName,
                    VoucherNumber: "",
                    TotalAmount: 0,
                    TotalEarning: 0,
                    TotalOrders: 0,
                    TotalDeduction: 0,
                    TotalCommission: 0,
                    TotalBonus: 0,

                    PayType: "Per Order",
                    Field1: "",
                    Field2: "",
                    Field3: "",
                    Field4: "",
                    Field5: "",
                    Field6: "",
                    Field7: "",
                    Field8: "",
                    Field9: "",
                    Field10: "",

                    DriverPaymentSheetDetails: [],
                    DriverPaymentSheetCosts: [],
                }

                console.log($scope);




                $scope.ErrorText = "";
                $scope.Load = false;




                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Driver Payment Sheet").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;


                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Driver Payment Sheet").then(function (response) {
                            $scope.CostCenters = response.data;

                            for (var i = 0; i < 5; i++) {
                                $scope.InsertRow();
                            }

                        });

                        MainService.GetNextDriverPaymentSheetNo().then(function (response) {
                            $scope.driverData.VoucherNumber = response.data;
                        });


                    })

                }


            }
            $scope.Init();

            $scope.CustomerAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.CustomerInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.CustomerAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountMaster = {};
                    $scope.SelectedCE.AccountMaster = data;
                    $scope.SelectedCE.AccountMasterId = data.Id;
                    $scope.$apply();
                    $scope.click($scope.SelectedCE, 1);
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };

            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                if ($scope.SelectedCE.AccountMasterId > 0) {
                    MainService.CheckCustomerDriverPayConfig($scope.SelectedCE).then(function (response2) {
                        if (response2.data != null && response2.data != "") {
                            var configdata = response2.data;


                            if ($scope.SelectedCE.PayType == 'Per Month') {
                                $scope.SelectedCE.MonthlyAmount = configdata.Amount;

                                $scope.SelectedCE.PerOrderRate = $scope.SelectedCE.MonthlyAmount / $scope.SelectedCE.TotalDays;
                                $scope.SelectedCE.CompanyCommission = configdata.Commission / $scope.SelectedCE.TotalDays;

                                $scope.SelectedCE.PerOrderRate = Math.round($scope.SelectedCE.PerOrderRate * 100) / 100;
                                $scope.SelectedCE.CompanyCommission = Math.round($scope.SelectedCE.CompanyCommission * 100) / 100;
                            } else {
                                $scope.SelectedCE.PerOrderRate = configdata.Amount;
                                $scope.SelectedCE.CompanyCommission = configdata.Commission;
                            }


                            $scope.calculate();
                        } else {
                            $scope.calculate();
                        }
                    })
                }

            }

            $scope.calculate = function () {
                $scope.SelectedCE.TotalAmount = $scope.SelectedCE.PerOrderRate * $scope.SelectedCE.TotalOrders;
                $scope.SelectedCE.TotalCompanyAmount = $scope.SelectedCE.CompanyCommission * $scope.SelectedCE.TotalOrders;

                $scope.SelectedCE.TotalAmount = Math.round($scope.SelectedCE.TotalAmount * 100) / 100;
                $scope.SelectedCE.TotalCompanyAmount = Math.round($scope.SelectedCE.TotalCompanyAmount * 100) / 100;

                $scope.SelectedCE.TotalDeduction = $scope.SelectedCE.Deduction1 + $scope.SelectedCE.Deduction2 + $scope.SelectedCE.Deduction3 + $scope.SelectedCE.Deduction4 + $scope.SelectedCE.Deduction5 + $scope.SelectedCE.Deduction6;

                $scope.SelectedCE.TotalEarned = $scope.SelectedCE.TotalAmount - $scope.SelectedCE.TotalCompanyAmount - $scope.SelectedCE.TotalDeduction + $scope.SelectedCE.Bonus;
                $scope.SelectedCE.TotalEarned = Math.round($scope.SelectedCE.TotalEarned * 100) / 100;

                $scope.driverData.TotalAmount = 0;
                $scope.driverData.TotalOrders = 0;
                $scope.driverData.TotalDeduction = 0;
                $scope.driverData.TotalCommission = 0;
                $scope.driverData.TotalEarning = 0;
                $scope.driverData.TotalBonus = 0;

                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {
                    $scope.driverData.TotalOrders = $scope.driverData.TotalOrders + e.TotalOrders;
                    $scope.driverData.TotalAmount = $scope.driverData.TotalAmount + e.TotalAmount;
                    $scope.driverData.TotalDeduction = $scope.driverData.TotalDeduction + e.TotalDeduction;
                    $scope.driverData.TotalCommission = $scope.driverData.TotalCommission + e.TotalCompanyAmount;
                    $scope.driverData.TotalEarning = $scope.driverData.TotalEarning + e.TotalEarned;
                    $scope.driverData.TotalBonus = $scope.driverData.TotalBonus + e.Bonus;
                })

            }

            $scope.IsSavePrint = false;
            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ErrorText = "";

                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {

                    e.DriverPaymentSheetCosts = [];
                    angular.forEach(e.CostCenters, function (a) {
                        if (a.Section == "Body") {
                            if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                            } else {
                                if (a.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: a.SelectedCostCenterId,
                                    }
                                    e.DriverPaymentSheetCosts.push(cst);
                                    console.log(e);
                                }
                            }
                        }
                    })

                    e.CostCenters = [];

                })

                $scope.driverData.DriverPaymentSheetCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.driverData.DriverPaymentSheetCosts.push(cst);
                            }
                        }
                    }
                })


                if ($scope.ErrorText == "") {
                    $('#saveModal').modal('show');
                } else {
                    toastr.warning($scope.ErrorText);
                }


            }

            $scope.SaveWithConfirm = function () {

                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.driverData.DateString = $scope.extractDate($scope.driverData.Date);
                $scope.driverData.CreatedBy = {};
                $scope.driverData.UpdateddBy = {};
                $scope.driverData.PayType = $scope.driverData.PayType;

                angular.forEach($scope.driverData.DriverPaymentSheetDetails, function (e) {
                    e.AccountMaster = {};
                    e.Employee = {};
                })

                MainService.AddDriverPaymentSheet($scope.driverData).then(function (response) {
                    if (response.data == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Driver Payment Sheet',$scope.driverData.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $('#mymodal2').modal('hide');
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("driverPaymentSheets");
                } else {
                    $scope.Init();
                }

            }


            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    if ($scope.driverData.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }


            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteDriverPaymentSheet($scope.driverData.Id).then(function (response) {
                        if (response.data) {
                            toastr.success("Deleted");
                            $('#deleteModal').modal('hide');
                            $state.go("timeSheets");
                        } else {
                            toastr.warning("Failed");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                    })
            }


            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.deleteRow = function () {
                var index = $scope.driverData.DriverPaymentSheetDetails.indexOf($scope.ClickedRow);
                $scope.driverData.DriverPaymentSheetDetails.splice(index, 1);
            }

            $scope.GetBackVoucher = function (type) {
                var temp = 0;
                if ($scope.driverData.Id > 0) {
                    temp = $scope.driverData.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackDriverPaymentSheet(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentCPV.CPVDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });



                    }])
